import Button from '@/components/Button';

import styles from '../SignIn.module.scss';

export const GoogleCircleButton = ({ googleLogin, ariaLabel }: { googleLogin: () => void; ariaLabel: string }) => (
  <Button className={styles.googleLoginContainer} onClick={googleLogin} variant="cta" ariaLabel={ariaLabel}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_262_4353" maskUnits="userSpaceOnUse" x="8" y="6" width="8" height="9">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9947 8.1824C15.9947 7.61671 15.9428 7.07271 15.8463 6.55054H8.16016V9.63661H12.5523C12.3631 10.6339 11.7881 11.4789 10.9238 12.0445V14.0463H13.5612C15.1044 12.6574 15.9947 10.6121 15.9947 8.1824Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_262_4353)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.16016 14.0463H15.9947V6.55054H8.16016V14.0463Z"
          fill="#5070A8"
        />
      </g>
      <mask id="mask1_262_4353" maskUnits="userSpaceOnUse" x="0" y="9" width="14" height="7">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.16012 15.9792C10.3636 15.9792 12.211 15.2648 13.5612 14.0463L10.9238 12.0445C10.1929 12.5232 9.25816 12.8061 8.16012 12.8061C6.03455 12.8061 4.23539 11.4027 3.5937 9.51691H0.867188V11.584C2.21004 14.1914 4.96988 15.9792 8.16012 15.9792Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_262_4353)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.867188 15.9792H13.5612V9.51691H0.867188V15.9792Z"
          fill="#2F9E4F"
        />
      </g>
      <mask id="mask2_262_4353" maskUnits="userSpaceOnUse" x="0" y="4" width="4" height="8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.59454 9.51694C3.43129 9.03829 3.33854 8.52696 3.33854 8.00111C3.33854 7.4753 3.43129 6.96398 3.59454 6.48528V4.41827H0.868034C0.315324 5.49529 0 6.71376 0 8.00111C0 9.2885 0.315324 10.507 0.868034 11.584L3.59454 9.51694Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_262_4353)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 11.584H3.59454V4.41827H0V11.584Z" fill="#EFB529" />
      </g>
      <mask id="mask3_262_4353" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="7">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.16012 3.19612C9.35828 3.19612 10.4341 3.59867 11.2798 4.38922L13.6206 2.10095C12.2072 0.813598 10.3599 0.0230103 8.16012 0.0230103C4.96988 0.0230103 2.21004 1.81084 0.867188 4.41826L3.5937 6.48526C4.23539 4.59955 6.03455 3.19612 8.16012 3.19612Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_262_4353)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.867188 6.48526H13.6206V0.0230103H0.867188V6.48526Z"
          fill="#D53E36"
        />
      </g>
    </svg>
  </Button>
);
